export enum DimensionGroup {
  HighLevel = 'High Level',
  BookedTotals = 'Booked Totals',
  Creative = 'Creative',
  Inventory = 'Inventory',
  Geography = 'Geography',
  Daypart = 'Daypart',
  Audience = 'Audience',
  Conversions = 'Conversions',
  CPM = 'CPM',
}

export default DimensionGroup;
